import { Module } from 'vuex';
import { defaultCostBreakdownData } from '@/features/common/raw';
import Dashboard from '../types';
import mutations from './mutations';
import getters from './getters';
import actions from './actions';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const dashboard: Module<Dashboard, any> = {
  state: {
    widgets: {
      shippingTips: {
        size: 'small',
        show: false,
        name: 'Shipping Tips & Resources',
        position: 1,
      },
      howItWorks: {
        size: 'big',
        show: false,
        name: 'How it works',
        position: 1,
      },
      recentShipments: {
        size: 'big',
        show: false,
        name: 'Recent Shipments',
        position: 2,
        itemsShown: 3,
        shipments: [],
        // customSettings: {
        //   created: true,
        //   intransit: false,
        //   exception: true,
        //   delivered: true,
        // },
      },
      scheduledPickups: {
        size: 'big',
        show: false,
        name: 'Scheduled Pickups',
        position: 3,
        itemsShown: 10,
        pickups: [],
      },
      transitStatus: {
        size: 'small',
        show: false,
        name: 'Transit Status',
        position: 2,
        transits: {
          created: 0,
          intransit: 0,
          exception: 0,
          delivered: 0,
        },
      },
      topDestinations: {
        size: 'small',
        show: false,
        name: 'Top Destinations',
        position: 3,
        itemsShown: 3,
        destinations: [],
        // customSettings: {
        //   range: 'Last7Days',
        //   fromDate: '2021-01-01',
        //   toDate: '2021-01-15',
        // },
      },
      // topChannels: {
      //   show: true,
      //   name: 'Top Sales Channels',
      //   channels: [
      //     {
      //       qty: 56,
      //       name: 'Shopify',
      //       subname: 'channel',
      //     },
      //     {
      //       qty: 16,
      //       name: 'Kickstarter',
      //       subname: 'channel',
      //     },
      //     {
      //       qty: 12,
      //       name: 'Direct Sales',
      //       subname: 'channel',
      //     },
      //   ],
      // },
      costBreakdown: {
        position: 4,
        size: 'big',
        show: false,
        name: 'Cost Breakdown',
        data: defaultCostBreakdownData,
      },
    },
    dashboardSettings: {
      firstname: '',
      timeOfDay: '',
      hasShipped: true,
    },
    showCustomizeTooltip: false,
    customizeTooltipStep: 1,
    isDashboardSettings: 0,
  },
  mutations,
  getters,
  actions,
};

export default dashboard;
